import { render, staticRenderFns } from "./WidgetRefreshInterval.vue?vue&type=template&id=5db5ad54"
import script from "./WidgetRefreshInterval.vue?vue&type=script&lang=js"
export * from "./WidgetRefreshInterval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports